package com.essntl.features.paymentparameter.data.di

import org.koin.core.annotation.ComponentScan
import org.koin.core.annotation.Module

@Module
@ComponentScan("com.essntl.features.paymentparameter.data")
class PaymentParameterModule
